import { Form, Field, TextInput, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { CountryOfOriginField } from '@/components/common';

/**
 * Props:
 *   formOptions  useValidateDeclarationFormOptions() result
 */
export const ProductInformationSection = ({ formOptions }) => {
  const t = useTranslations();

  return (
    <Form.Section title={t('SECTION_GENERAL_INFORMATION')}>
      <Form.Row columns={2}>
        <Field name="typeOfProduct" required>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            // TODO: creatable (add-new-value) once @carboledger/ui's Dropdown exposes the query.
            <Dropdown
              id={id}
              name={name}
              label={t('FIELD_TYPE_OF_PRODUCT')}
              placeholder={t('FORM_SELECT_TYPE_OF_PRODUCT')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
              options={formOptions.productTypeOptions}
              searchable
            />
          )}
        </Field>

        <Field name="typeOfRawMaterial" required>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <Dropdown
              id={id}
              name={name}
              label={t('FIELD_TYPE_OF_RAW_MATERIAL')}
              placeholder={t('FORM_SELECT_TYPE_OF_RAW_MATERIAL')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
              options={formOptions.rawMaterialTypeOptions}
              searchable
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={2}>
        <Field name="additionalInformation">
          {({ id, name, value, onChange, onBlur, status, message }) => (
            <TextInput
              id={id}
              name={name}
              label={t('FORM_ADDITIONAL_INFORMATION')}
              placeholder={t('FORM_ADDITIONAL_INFORMATION_PLACEHOLDER')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
            />
          )}
        </Field>

        <CountryOfOriginField options={formOptions.countryOptions} required />
      </Form.Row>
    </Form.Section>
  );
};
